<template>
    <div id="login" class="qf-pt-70px qf-pb-70px">
        <div class="container">
            <form @submit.prevent="login">
                <div class="row justify-content-right align-items-right ">
                    <div class="col text-right">
                        <span class="text-uppercase ">{{$ml.get('missing_account')}}</span>&nbsp;&nbsp;
                        <router-link to="/signup" class="btn btn-outline-light text-uppercase pr-4 pl-4">
                            {{$ml.get('sign_up')}}
                        </router-link>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center py-5">
                    <div class="col text-center">
                        <router-link to="/">
                            <img src="../../assets/logo2.png" alt="ТМ">
                        </router-link>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center py-3">
                    <div class="col text-center">
                        <h2>{{$ml.get('login')}}</h2>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center mb-4">
                    <div class="col col-sm-5 position-relative form-group">
                        <div class="input-icon">
                            <font-awesome-icon icon="envelope"/>
                        </div>
                        <input type="email" class="bg-transparent form-control input-with-icon"
                               :class="{'is-invalid': errors.has('email')}" :placeholder="$ml.get('email')"
                               v-model="loginData.username" name="email" v-validate="'required|email'">
                    </div>
                </div>

                <div class="row justify-content-center align-items-center">
                    <div class="col col-sm-5 position-relative form-group">
                        <div class="input-icon">
                            <font-awesome-icon icon="lock"/>
                        </div>
                        <input type="password" class="bg-transparent form-control input-with-icon"
                               :class="{'is-invalid': errors.has('password')}" :placeholder="$ml.get('password')"
                               v-model="loginData.password" name="password" v-validate="'required'">
                        <small class="form-text text-danger pl-3"
                               v-if="errorMessage.length">
                            {{errorMessage}}
                        </small>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center mt-5">
                    <div class="col-5 pt-1 text-center">
                        <font-awesome-icon icon="spinner" size="2x" class="fa-spin" v-if="loading"/>
                        <button v-else class="btn btn-lg text-uppercase btn-block btn-warning" type="submit">
                            {{$ml.get('button_login')}}
                        </button>

                    </div>
                </div>

                <div class="row justify-content-center align-items-center mt-1">
                    <router-link to="/forgotten-password" class="text-uppercase qf-white-link small">
                        {{$ml.get('forgot_password_q')}}
                    </router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login",
        data() {
            return {
                loginData: {
                    username: '',
                    password: '',
                },
                errorMessage: '',
                loading: false,
            }
        },
        methods: {
            login() {
                if (!this.loading) {
                    this.errorMessage = '';
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            this.$store.dispatch('login', this.loginData).then(() => {
                                this.loading = false;
                            }).catch(error => {
                                if (error && error.status === 400) {
                                    this.errorMessage = error.data.error_description;
                                }
                                this.loading = false;
                            });
                        }
                    });
                }
            }
        }

    }
</script>

<style scoped>
    #login {
        color: #ffffff;
        background-image: url("../../assets/background.jpg");
        background-size: cover;
        background-attachment: fixed;
    }

    .form-control {
        border-color: #ffffff;
        color: #ffffff;
    }

    .form-control.is-invalid {
        border-color: #dc3545;
        color: #ffffff;
    }

    input::placeholder {
        color: #ffffff;
    }
</style>
